import { FormEventHandler, MutableRefObject, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Company, GroupSearchConditions } from '../../../api/model';
import SlideToggle from '../../modules/SlideToggle';

interface Props {
  companies: Company[];
  defaultConditions: GroupSearchConditions;
  conditionsRef: MutableRefObject<GroupSearchConditions>;
  setConditionsAndSearch: (value: GroupSearchConditions) => void;
}

function OrganizationSearch({ companies, defaultConditions, conditionsRef, setConditionsAndSearch }: Props) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(true);

  // フォーム情報
  const { register, handleSubmit } = useForm<GroupSearchConditions>({
    defaultValues: { ...defaultConditions },
  });

  const handleOpen = () => {
    setOpen(!open);
  };

  // フォーム送信
  const onSubmit: FormEventHandler<HTMLFormElement> = (e) => {
    e.preventDefault();
    void handleSubmit((data) => {
      const next: GroupSearchConditions = {
        ...conditionsRef.current,
        company_id: data.company_id,
        group_name_ja: data.group_name_ja,
        group_name_en: data.group_name_en,
        team_name_ja: data.team_name_ja,
        team_name_en: data.team_name_en,
        user_id_text: data.user_id_text,
        user_name: data.user_name,
        hidden: data.hidden,
      };
      // 検索実行など
      setConditionsAndSearch(next);
    })();
  };

  return (
    <>
      <h3 className="trig" onClick={handleOpen} style={{ display: 'inline-block' }}>
        <span>
          {t('グループ検索')}
          <i className={`fa-solid ${open ? 'fa-chevron-down' : 'fa-chevron-up'}`} />
        </span>
      </h3>
      <SlideToggle open={open}>
        <form id="search-conditions" onSubmit={onSubmit}>
          <div className="wfr scondition trigfr relativefr contbtad pb20 fropen">
            <div className="sepfr3 mb0 spm">
              <div className="labip1">
                <div>
                  <label htmlFor="company_name">{t('会社名')}</label>
                  <span className="dropdown">
                    <select {...register('company_id')}>
                      <option key="" value="">
                        {t('選択してください')}
                      </option>
                      {companies.map((company) => (
                        <option key={company.company_id} value={company.company_id}>
                          {company.company_name}
                        </option>
                      ))}
                    </select>
                  </span>
                </div>
                <div>
                  <label htmlFor="groupNameJa">{t('グループ名（日）')}</label>
                  <input type="text" {...register('group_name_ja')} />
                </div>
                <div>
                  <label htmlFor="groupNameEn">{t('グループ名（英）')}</label>
                  <input type="text" {...register('group_name_en')} />
                </div>
              </div>
              <div className="labip1">
                <div>
                  <label htmlFor="team_name_ja">{t('チーム名（日）')}</label>
                  <input type="text" {...register('team_name_ja')} />
                </div>
                <div>
                  <label htmlFor="team_name_en">{t('チーム名（英）')}</label>
                  <input type="text" {...register('team_name_en')} />
                </div>
              </div>

              <div className="labip1">
                <div>
                  <label htmlFor="user_id_text">{t('ユーザーID')}</label>
                  <input type="text" {...register('user_id_text')} />
                </div>
                <div>
                  <label htmlFor="user_name">{t('ユーザー名')}</label>
                  <input type="text" {...register('user_name')} />
                </div>
              </div>
            </div>

            <div className="controlfr mt0">
              <span className="ck">
                <input id="hidden" type="checkbox" {...register('hidden')} />{' '}
                <label htmlFor="hidden">{t('非表示グループを表示')}</label>
              </span>
              <span>
                <input id="search" name="search" type="submit" value={t('検索').toString()} className="searchbtn" />
              </span>
            </div>
          </div>
        </form>
      </SlideToggle>
    </>
  );
}

export { OrganizationSearch };
